const DEVICE_ID_KEY = "soorgaa_device_id";
const ADMIN_DEVICE_TOKEN_KEY = "soorgaa_admin_device_token";

export function getDeviceId(): string {
  try {
    let id = localStorage.getItem(DEVICE_ID_KEY);
    if (!id) {
      if (typeof crypto !== "undefined" && typeof crypto.randomUUID === "function") {
        id = crypto.randomUUID();
      } else {
        id = `dev_${Math.random().toString(36).slice(2)}_${Date.now()}`;
      }
      localStorage.setItem(DEVICE_ID_KEY, id);
    }
    return id;
  } catch {
    return "browser_device";
  }
}

export function getAdminDeviceToken(): string | null {
  try {
    return localStorage.getItem(ADMIN_DEVICE_TOKEN_KEY);
  } catch {
    return null;
  }
}

export function setAdminDeviceToken(token: string): void {
  try {
    localStorage.setItem(ADMIN_DEVICE_TOKEN_KEY, token);
  } catch {
    // local storage unavailable
  }
}

export function clearAdminDeviceToken(): void {
  try {
    localStorage.removeItem(ADMIN_DEVICE_TOKEN_KEY);
  } catch {
    // local storage unavailable
  }
}

export function getDeviceName(): string {
  try {
    const ua = navigator.userAgent;
    let platform = "Browser";
    if (ua.includes("Windows")) platform = "Windows PC";
    else if (ua.includes("Macintosh") || ua.includes("Mac OS")) platform = "Mac";
    else if (ua.includes("Android")) platform = "Android";
    else if (ua.includes("iPhone") || ua.includes("iPad")) platform = "iOS";
    else if (ua.includes("Linux")) platform = "Linux";

    let browser = "Web";
    if (ua.includes("Edg/")) browser = "Edge";
    else if (ua.includes("Chrome/")) browser = "Chrome";
    else if (ua.includes("Firefox/")) browser = "Firefox";
    else if (ua.includes("Safari/") && !ua.includes("Chrome/")) browser = "Safari";

    return `${platform} (${browser})`;
  } catch {
    return "Web Browser";
  }
}
